import { usePostHttp } from "../../http.hook";

interface IBody {
  asset: string;
  favouriteSocial: string;
}

export interface ICSVUpload {
  id: string;
  title: string;
  successCount: number;
  failedCount: number;
  favouriteSocial: string;
  createdBy: {
    id: string;
    name: string;
    email: string;
    accountType: string;
  };
  createdAt: Date;
}

interface IResponse {
  csvLog: ICSVUpload;
}

export function useAddNewCsvFavoriteCollectionAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/favourite-socials/csv",
  });
}
